import React from 'react';
import styled from 'astroturf/react';
import _Container from "SidebarSection-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/SidebarSection.tsx?styleId=Container";
import _Heading from "SidebarSection-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/SidebarSection.tsx?styleId=Heading";


const Container = /*#__PURE__*/styled("section", null, {
  displayName: "Container",
  styles: _Container
});

const Heading = /*#__PURE__*/styled("header", null, {
  displayName: "Heading",
  styles: _Heading
});

type Props = {
  heading: React.ReactNode;
  compact?: boolean;
};

export const SidebarSection: React.FC<React.PropsWithChildren<Props>> = ({
  heading,
  compact,
  children,
}) => {
  return (
    <Container
      style={{
        gap: compact
          ? 'var(--spacing-xs-16, 16px)'
          : 'var(--spacing-sm-24, 24px)',
      }}
    >
      <Heading>{heading}</Heading>
      {children}
    </Container>
  );
};
